import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import type { AllProductsSort, StorefrontCatalogListResponse } from './storefront-catalog-list.model';

export interface AllProductsListParams {
  pageNumber: number;
  pageSize: number;
  sortBy: AllProductsSort;
  categoryIds: number[];
  productTypes: string[];
  promotionalCampaignPublicId?: string | null;
  search?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class AllProductsService {
  private readonly http = inject(HttpClient);

  getCatalogList(params: AllProductsListParams): Observable<StorefrontCatalogListResponse> {
    let httpParams = new HttpParams()
      .set('pageNumber', String(params.pageNumber))
      .set('pageSize', String(params.pageSize))
      .set('sortBy', params.sortBy);

    if (params.categoryIds.length > 0) {
      httpParams = httpParams.set('categoryIds', params.categoryIds.map(String).join(','));
    }

    if (params.productTypes.length > 0) {
      httpParams = httpParams.set('productTypes', params.productTypes.join(','));
    }

    if (params.promotionalCampaignPublicId) {
      httpParams = httpParams.set(
        'promotionalCampaignPublicId',
        params.promotionalCampaignPublicId,
      );
    }

    const search = params.search?.trim();
    if (search) {
      httpParams = httpParams.set('search', search);
    }

    return this.http.get<StorefrontCatalogListResponse>(
      `${environment.apiUrl}Storefront/GetProductCatalogList`,
      { params: httpParams },
    );
  }
}
